<div class="sidebar-container" [ngClass]="{'collapsed': isCollapsed}">
  <div class="sidebar-header">
    <img routerLink="dashboard" [hidden]="isCollapsed" src="assets/images/header-logo.svg" alt="logo-img"/>
    <img routerLink="dashboard" class="c2-logo" [hidden]="!isCollapsed" src="assets/icons/icon-logo-c2.svg" alt="logo-img"/>
    <div class="expander" (click)="onExpanderClick()">
      <img class="vector-icon" src="assets/icons/icon-vector.svg" alt="vector"/>
    </div>
    <div class="tooltip">{{isCollapsed ? 'Expand menu' : 'Collapse menu'}}</div>
  </div>

  <div class="menu-items">
    <div
      [routerLink]="'dashboard'"
      [routerLinkActive]="['active']"
      class="menu-item"
    >
      <div class="icon-container">
        <img [hidden]="!isActiveRoute('dashboard')" class="menu-item-icon" src="assets/icons/icon-home-active.svg"
          alt="home-icon" />
        <img [hidden]="isActiveRoute('dashboard')" class="menu-item-icon" src="assets/icons/icon-home.svg" alt="home-icon" />
      </div>
      <div class="sub-menu-container">
        <div
          [routerLink]="'dashboard'"
          [routerLinkActive]="['active']"
          class="sub-menu-item"
        >
          Home
        </div>
      </div>
      <div class="extra-hover-area"></div>
    </div>

    <div
      [routerLink]="'inventory/ndc'"
      [routerLinkActive]="['active']"
      class="menu-item sub-menu"
    >
      <img class="submenu-chevron-icon" src="assets/icons/icon-submenu-chevron.svg" alt="submenu-chevron"/>
      <div class="icon-container inventory">
        <img [hidden]="!isActiveRoute('inventory')" class="menu-item-icon" src="assets/icons/icon-folder-active.svg"
          alt="home-folder" />
        <img [hidden]="isActiveRoute('inventory')" class="menu-item-icon" src="assets/icons/icon-folder.svg"
          alt="home-folder" />
      </div>
      <div class="sub-menu-container">
        <div
          (click)="$event.stopPropagation()"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="'inventory/ndc'"
          [routerLinkActive]="['active']"
          class="sub-menu-item"
        >
          Inventory
        </div>
        <div
          (click)="$event.stopPropagation()"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="'inventory/bulk-add'"
          [routerLinkActive]="['active']"
          class="sub-menu-item">
          Bulk Add
        </div>
        <div *ngIf="isNotBasicPlan"
          (click)="$event.stopPropagation()"
          [routerLinkActiveOptions]="{ exact: !isOrderHistoryDynamicChild }"
          [routerLink]="'inventory/order-history'"
          [routerLinkActive]="['active']"
          class="sub-menu-item">
          Purchase Orders
        </div>
        <div
          (click)="$event.stopPropagation()"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLink="inventory/sales-to-providers-history"
          [routerLinkActive]="['active']"
          class="sub-menu-item">
          Sales to Providers
        </div>
        <div
          (click)="$event.stopPropagation()"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLink="inventory/sales-to-reverse-distributors-history"
          [routerLinkActive]="['active']"
          class="sub-menu-item">
          Sales to Reverse Distributors
        </div>
        <div
          (click)="$event.stopPropagation()"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLink="inventory/returns-to-wholesalers-history"
          [routerLinkActive]="['active']"
          class="sub-menu-item">
          Returns to Wholesalers
        </div>
        <div
          (click)="$event.stopPropagation()"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLink="inventory/inventory-destructions-history"
          [routerLinkActive]="['active']"
          class="sub-menu-item">
          Wastes / Destructions
        </div>
        <div *ngIf="compoundingEnabled$ | async"
          (click)="$event.stopPropagation()"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLink="inventory/compounds"
          [routerLinkActive]="['active']"
          class="sub-menu-item">
          Compounds
        </div>
      </div>
      <div class="extra-hover-area"></div>
    </div>
    
    <div
      [routerLink]="'reports/custom-report'"
      [routerLinkActive]="['active']"
      class="menu-item sub-menu"
    >
      <img class="submenu-chevron-icon" src="assets/icons/icon-submenu-chevron.svg" alt="submenu-chevron"/>
      <div class="icon-container">
        <img [hidden]="!isActiveRoute('reports')" class="menu-item-icon" src="assets/icons/icon-chart-active.svg"
          alt="home-chart" />
        <img [hidden]="isActiveRoute('reports')" class="menu-item-icon" src="assets/icons/icon-chart.svg" alt="home-chart" />
      </div>
      <div class="sub-menu-container">
        <div *ngIf="!isCollapsed"
          [routerLink]="'reports/custom-report'"
          class="sub-menu-item reports"
        >
          Reports
        </div>
        <div
          (click)="$event.stopPropagation()"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLink="reports/custom-report"
          [routerLinkActive]="['active']"
          class="sub-menu-item"
        >
          Custom Report
        </div>
        <div
          (click)="$event.stopPropagation()"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLink="reports/current-On-Hand"
          [routerLinkActive]="['active']"
          class="sub-menu-item"
        >
          Current On-Hand 
        </div>
        <div
          (click)="$event.stopPropagation()"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLink="reports/similar-on-hand-history"
          [routerLinkActive]="['active']"
          class="sub-menu-item"
        >
          Similar On-Hand 
        </div>

        <div
          (click)="$event.stopPropagation()"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['reports', 'dea-compliance']"
          [routerLinkActive]="['active']"
          class="sub-menu-item"
        >
          DEA Compliance
        </div>
        <div
          (click)="$event.stopPropagation()"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLink="reports/inventory-snapshot-report"
          [routerLinkActive]="['active']"
          class="sub-menu-item"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          Inventory Totals
        </div>
        <div
          (click)="$event.stopPropagation()"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLink="reports/ndc-purchase-report"
          [routerLinkActive]="['active']"
          class="sub-menu-item"
          [routerLinkActiveOptions]="{ exact: true }"
        >
        NDC Purchase Report
      </div>
      </div>
      <div class="extra-hover-area"></div>
    </div>

      <div
      [routerLink]="'audits'"
      [routerLinkActive]="['active']"
      class="menu-item"
      >
      <div class="icon-container">
        <img [hidden]="!isActiveRoute('audits')" class="menu-item-icon" src="assets/icons/icon-audits-active.svg"
          alt="users-icon" />
        <img [hidden]="isActiveRoute('audits')" class="menu-item-icon" src="assets/icons/icon-audits.svg" alt="users-icon" />
      </div>
      <div class="sub-menu-container">
        <div
          [routerLink]="'audits'"
          [routerLinkActive]="['active']"
          class="sub-menu-item"
        >
          Audits
        </div>
      </div>
      <div class="extra-hover-area"></div>
    </div>

    <div
      *ngIf="(activeUserIsLoggedInUser$ | async) && adminRoles.includes((currentPharmacy$ | async)?.role)"
      [routerLink]="'team'"
      [routerLinkActive]="['active']"
      class="menu-item"
    >
      <div class="icon-container">
        <img [hidden]="!isActiveRoute('team')" class="menu-item-icon" src="assets/icons/icon-users-active.svg"
          alt="users-icon" />
        <img [hidden]="isActiveRoute('team')" class="menu-item-icon" src="assets/icons/icon-users.svg" alt="users-icon" />
      </div>
      <div class="sub-menu-container">
        <div
          [routerLink]="'team'"
          [routerLinkActive]="['active']"
          class="sub-menu-item"
        >
          Team
        </div>
      </div>
      <div class="extra-hover-area"></div>
    </div>

    <div
      *ngIf="(activeUserIsLoggedInUser$ | async) && adminRoles.includes((currentPharmacy$ | async)?.role)"
      [routerLink]="'settings'"
      [routerLinkActive]="['active']"
      class="menu-item"
    >
      <div class="icon-container">
        <img [hidden]="!isActiveRoute('settings')" class="menu-item-icon" src="assets/icons/icon-settings-active.svg"
          alt="home-settings" />
        <img [hidden]="isActiveRoute('settings')" class="menu-item-icon" src="assets/icons/icon-settings.svg"
          alt="home-settings" />
      </div>
      <div class="sub-menu-container">
        <div
          [routerLink]="'settings'"
          [routerLinkActive]="['active']"
          class="sub-menu-item"
        >
          Settings
        </div>
      </div>
      <div class="extra-hover-area"></div>
    </div>

    <div class="menu-item">
      <div class="icon-container" (click)="openTutorials()">
        <img class="menu-item-icon" src="assets/icons/icon-play.svg" alt="tutorials-link" />
      </div>
      <div class="sub-menu-container">
        <a [href]="TUTORIALS_LINK" target="_blank" class="sub-menu-item">
          Tutorials
        </a>
      </div>
      <div class="extra-hover-area"></div>
    </div>

    <div class="menu-item"
    (click)="openCustomerSupport()">
    <div class="icon-container help">
      <img class="menu-item-icon" src="assets/icons/icon-customer-support.svg" alt="customer-portal-link" />
    </div>
    <div class="sub-menu-container">
      <div class="sub-menu-item" (click)="$event.stopPropagation(); openCustomerSupport()">
        Help
      </div>
    </div>
    <div class="extra-hover-area"></div>
  </div>
  
    <div class="menu-item" *ngIf="(activeUserIsLoggedInUser$ | async) && adminRoles.includes((currentPharmacy$ | async)?.role)"
      (click)="openCustomerPortal()" data-cb-type="portal">
      <div class="icon-container">
        <img class="menu-item-icon" src="assets/icons/icon-customer-portal.svg" alt="customer-portal-link" />
      </div>
      <div class="sub-menu-container">
        <a [href]="CUSTOMER_PORTAL_LINK_SAFE" data-cb-type="portal" class="sub-menu-item" target="_blank">
          Customer Portal
        </a>
      </div>
      <div class="extra-hover-area"></div>
    </div>

  </div>

  <div [routerLink]="'constructor'" *ngIf="!environment.production" class="constructor">
    Constructor
  </div>
</div>
